<template>
    <transition>
        <v-dialog-old ref="dialog" id="newsModeration" @hidden="clearHash()" :onCloseEsc="clearHash">
            <ValidationObserver ref="modCompare">
                <mod-compare v-if="loaded"
                             :disabled="$canNot('admin.moderation.news.update')"
                             :o="M.old" :n="M.new" :f.sync="M.final"
                             :options="modOptions" :blocks="modBlocks"
                />
            </ValidationObserver>
            <footer v-can="'admin.moderation.news.update'">
                <v-loading-component @click="update">
                    <template slot-scope="{ loadingClass }">
                        <button :class="['green', loadingClass]">Сохранить</button>
                    </template>
                </v-loading-component>
                <button v-if="M.info.approved === 1" class="" @click="cancel">Отменить</button>
                <button class="red"  v-if="M.info.approved === 0" @click="deleteNews">Удалить</button>
                <label class="float-right d-inline-block" style="display: inline-block">
                    <input type="checkbox" v-model="autoNext" @change="autoNextChange"><span>Открывать следующую</span>
                </label>
            </footer>
        </v-dialog-old>
    </transition>
</template>
<script>
import ModCompare from "@common/modCompare/ModCompare.vue"
import { modBlocks, modDefault, modOptions } from "./NewsFields";

export default {
    name: "NewsModeration",
    components: {
        ModCompare
    },
    data: function () {
        return {
            M: {
                old: modDefault(),
                new: modDefault(),
                final: modDefault(),
                info: {
                    id: '',
                    approved: -1,
                    moderation_id: '',
                }
            },
            modOptions: modOptions(),
            modBlocks: modBlocks,
            loaded: false,
            autoNext: localStorage.getItem(window.location.pathname + '@autoNext') !== null
                ? localStorage.getItem(window.location.pathname + '@autoNext') === 'true' : false,
        }
    },
    mounted() {
        window.addEventListener('beforeunload', this.clearHash);
    },
    destroyed() {
        window.removeEventListener('beforeunload', this.clearHash);
    },
    methods:{
        update(btn) {
            this.$refs.modCompare.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    return;
                }
                btn.startLoadingAnimation();
                this.updateRequest().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
            });
        },
        updateRequest() {
            return this.axios.post('/admin/moderation/news/moderate/'+this.M.info.id, {
                fields: this.M.final,
                moderation_id: this.M.info.moderation_id,
            }).then(data => {
                this.fireUpdatedEvent()
            });
        },
        cancel() {
            this.$modal(`Вы действительно хотите отменить изменения?`,
                {
                    name: "Отменить изменения",
                    callback: () => {
                        this.cancelRequest();
                    }
                },
                {
                    name: "Нет"
                }
            );
        },
        deleteNews() {
            this.$modal(`Вы действительно хотите безвозвратно удалить новость?`,
                {
                    name: "Удалить новость",
                    btnClass: 'red',
                    callback: () => {
                        this.deleteRequest();
                    }
                },
                {
                    name: "Нет"
                }
            );
        },
        cancelRequest(){
            this.axios.post('/admin/moderation/news/cancel/' + this.M.info.moderation_id,{}).then(data => {
                this.fireUpdatedEvent()
            });
        },
        deleteRequest(){
            this.axios.post('/admin/moderation/news/delete/' + this.M.info.id,{}).then(data => {
                this.fireUpdatedEvent()
            });
        },
        fireUpdatedEvent: function () {
            if (this.autoNext) {
                this.$emit('openNext', this.M.info.id);
            } else {
                this.$emit('updated');
                this.$bus.fire('updateMenu');

            }
            this.$refs.dialog.hide();
        },
        showModal(id) {
            return this.getData(id);
        },
        getData(id) {
            let requestPromise = this.axios.get('/admin/moderation/news/' + id);

            requestPromise.then(data => {
                if (data.data.error) {
                    this.$modal(data.data.error, {
                        name: 'ОК',
                        callback: () => {}
                    }, {}, false, 'only-text-dialog');
                    return;
                }
                Object.assign(this.M, data.data);
                Object.assign(this.M.final, data.data.new);

                this.loaded = true;
                this.$refs.dialog.show();
            });

            return requestPromise;
        },
        autoNextChange: function () {
            localStorage.setItem(window.location.pathname + '@autoNext', this.autoNext);
        },
        clearHash() {
            if (this.M.info.id) {
                this.axios.get('/admin/moderation/news/' + this.M.info.id + '/close');
            }

            window.location.hash = '';
        },
    }
}

</script>
<style lang="scss">
#newsModeration {
    max-width: 79%;

    & #cropper{
        max-height: 570px !important;
        width: 630px !important;
    }
    & .img-container {
        height: 380px;
        width: 510px !important;
        margin: 0 auto;
    }
    & .cropper-container.cropper-bg{
        margin: 0 auto;
        width: 500px !important;
    }

    & .imageCropper{
        width: 265px !important;
        height: 149px !important;

        & img{
            width: 265px !important;
            height: 149px !important;
        }
    }
    & .dataTable > tbody > tr > td[align="center"]>a>img{
        width: 265px !important;
        height: 149px !important;
    }
}
</style>
